import { useEffect, useState } from "react";
import { Loader2, Send } from "lucide-react";
import { WhatsAppGlyph } from "@/components/cards/CardShell";
import { fetchEventProgress, ron } from "@/lib/bf";

const waUrl = (c) => `https://wa.me/${c.wa}?text=${encodeURIComponent(c.msg)}`;

const Row = ({ c, min, sent, onSend }) => {
  const pct = min > 0 ? Math.min(100, Math.round((c.spent / min) * 100)) : 0;
  return (
    <li className="bf-inv-row" data-testid={`bf-inv-row-${c.lead}`}>
      <div className="bf-inv-head">
        <b>{c.salon || "Salon"}</b>
        <small>{[c.city, c.registered ? "înscris" : "interesat"].filter(Boolean).join(" · ")}</small>
        {c.wa ? <a className={`st-btn st-btn--light ${sent ? "is-sent" : ""}`} href={waUrl(c)} target="_blank" rel="noopener noreferrer" onClick={onSend} data-testid={`bf-inv-wa-${c.lead}`}><WhatsAppGlyph /> {sent ? "Trimis" : "Trimite"}</a>
          : <small className="bf-red-tag">fără telefon</small>}
      </div>
      {min > 0 && (
        <div className="bf-inv-prog" data-testid={`bf-inv-prog-${c.lead}`}>
          <span className="bf-inv-bar"><i style={{ width: `${pct}%` }} className={pct >= 100 ? "is-done" : ""} /></span>
          <small>{ron(c.spent)} din {ron(min)} · {c.missing > 0 ? `mai are ${ron(c.missing)}` : "prag atins"}</small>
        </div>
      )}
    </li>
  );
};

export default function BFEventInvite({ e, k = "" }) {
  const [d, setD] = useState(null);
  const key = `bf-inv-sent-${e.id}`;
  const [sent, setSentRaw] = useState(() => { try { return JSON.parse(localStorage.getItem(key)) || {}; } catch { return {}; } });
  const setSent = (f) => setSentRaw((s) => { const n = f(s); localStorage.setItem(key, JSON.stringify(n)); return n; });
  const regs = e.mine.join(",");
  useEffect(() => {
    let live = true;
    fetchEventProgress(e.id).then((x) => live && setD(x)).catch(() => live && setD({ error: true }));
    return () => { live = false; };
  }, [e.id, regs, k]);
  if (d?.error) return <p className="st-hint" data-testid={`bf-inv-err-${e.id}`}>Nu am putut încărca clienții. Închide și redeschide.</p>;
  if (!d) return <p className="st-hint"><Loader2 size={14} className="animate-spin" /> Se calculează achizițiile…</p>;
  const min = d.event.min_value;
  const todo = d.clients.filter((c) => c.wa && !sent[c.lead]);
  const mark = (id) => setSent((s) => ({ ...s, [id]: true }));
  const next = () => { const c = todo[0]; window.open(waUrl(c), "_blank", "noopener"); mark(c.lead); };
  const period = [d.event.from, d.event.to].filter(Boolean).map((x) => new Date(`${x}T12:00:00`).toLocaleDateString("ro-RO")).join(" – ");
  return (
    <div className="bf-inv" data-testid={`bf-inv-${e.id}`}>
      <p className="st-hint">Achiziții {d.event.pkg_name ? `din ${d.event.pkg_name}` : "din produsele evenimentului"}{period ? `, perioada ${period}${d.event.to ? "" : " – azi"}` : ""}.</p>
      {!d.clients.length ? <p className="st-hint" data-testid={`bf-inv-none-${e.id}`}>Nu ai clienți interesați sau înscriși la acest brand.</p> : (
        <>
          <button type="button" className="st-btn st-btn--silver" disabled={!todo.length} onClick={next} data-testid={`bf-inv-next-${e.id}`}>
            <Send size={14} /> {todo.length ? `Trimite invitația următorului client (${d.clients.filter((c) => c.wa).length - todo.length + 1}/${d.clients.filter((c) => c.wa).length})` : "Invitația a fost trimisă tuturor"}
          </button>
          {Object.keys(sent).length > 0 && <button type="button" className="bf-gate-switch" onClick={() => setSent(() => ({}))} data-testid={`bf-inv-reset-${e.id}`}>Reia trimiterea de la început</button>}
          <ul className="bf-inv-list">{d.clients.map((c) => <Row key={c.lead} c={c} min={min} sent={sent[c.lead]} onSend={() => mark(c.lead)} />)}</ul>
        </>
      )}
    </div>
  );
}
